import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { AUTH_CONFIG } from "../config/authConfig";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuthStore();
  const location = useLocation();

  // Redirigir usuarios autenticados a la página principal
  useEffect(() => {
    if (!loading && isAuthenticated) {
      // Usar replace para evitar que el usuario pueda volver atrás
      window.location.replace(AUTH_CONFIG.ROUTES.DEFAULT_REDIRECT);
    }
  }, [isAuthenticated, loading]);

  // Mostrar loading mientras se valida la autenticación
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  // Si está autenticado, no mostrar nada (se redirige)
  if (isAuthenticated) {
    return null;
  }

  // Solo mostrar contenido si no está autenticado
  return children;
};

export default PublicRoute; 